module.exports = {
  bg: "#D9D9D9",
  accent: "#79aacf",
  bright: "#ffffff",
  dark: "#333333",
  gray: "#777777"
};



// WEBPACK FOOTER //
// ./src/styles/colors.js